import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FaThumbsUp } from "react-icons/fa";
import ActionButton from "./ActionButton";
import { useChatActions } from "../../hooks/useChatActions";

const CheckersButton = () => {
  const viewer = useSelector((state) => state.viewer);
  const viewerLastUpdated = useSelector((state) => state.viewerLastUpdated);
  const [isDiagramLoaded, setIsDiagramLoaded] = useState(false);

  const { handleRunCheckers } = useChatActions();

  // Check if the diagram is loaded whenever viewer or viewerLastUpdated changes
  useEffect(() => {
    setIsDiagramLoaded(viewer?.getDefinitions()?.rootElements?.length > 0);
  }, [viewer, viewerLastUpdated]);

  return (
    <ActionButton
      icon={FaThumbsUp}
      tooltip="Run Checks"
      onClick={handleRunCheckers}
      disabled={!isDiagramLoaded} // Disable if no diagram is loaded
    />
  );
};

export default CheckersButton;
